module.exports = __webpack_public_path__ + "img/point_center.ea1e36bb.svg";